
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-a80f93b4&scoped=true!postcss!sass!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BeAnAnchor.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BeAnAnchor.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-a80f93b4!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BeAnAnchor.vue"),
  /* scopeId */
  "data-v-a80f93b4",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/anchor/helpCenter/BeAnAnchor.vue
// module id = 348
// module chunks = 0